module.exports = __webpack_public_path__ + "img/wz-3-7.3ca107a1.jpg";